module.exports = __webpack_public_path__ + "img/benefit_04.75780ad4.svg";